import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSuperblockQuotation, updateSuperblockQuotation } from 'src/_helpers/api';

const name = 'superblockQuotations';

const initialState = {
  quotations: [],
  error: null,
};

const addSuperblockQuotationAsync = createAsyncThunk(

	`${name}/add-superblock-quotation`,
	async (quotationData) => {
		//console.log("Inside addSuperblockQuotationAsync")
		// prendre la date d'aujourd'hui avec le bon format au lieu du formattage de JS pour le .json
		const monthNames = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin",
			"Juillet", "Aout", "Sep", "Oct", "Nov", "Dec"
		];
		const today = new Date();
		const day = `${today.getDate() < 10 ? "0" : ""}${today.getDate()}`;
		const year = today.getFullYear();
		const hours = today.getHours();
		const minutes = today.getMinutes();

		const formattedDate = `${day}/${monthNames[today.getMonth()]}/${year} ${hours}:${minutes}`;

		console.log("slice quotationData: ", quotationData)

		// Construire l'objet commun pour la création ou la mise à jour
		const apiDataCommon = {
			AirFlow_EA: quotationData.airFlowEA,
			AirFlow_FA: quotationData.airFlowFA,
			Arrangement: quotationData.arrangement,
			CancelPrecedentVersion: quotationData.cancelPrecedentVersion,
			CasingMaterial: quotationData.casingMaterial,
			City:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.city
					: null,
			Communication: quotationData.communication,
			CompanyName: quotationData.companyName,
			ContactName: quotationData.contactName,
			Controls: quotationData.controls,
			CoreMaterial: quotationData.coreMaterial,
			CorrugationHeight: quotationData.corrugationHeight,
			Country:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.country
					: null,
			Customer: quotationData.customer,
			Depth: quotationData.depth,
			Height: quotationData.height,
			IsActive: quotationData.isActive,
			Length: quotationData.length,
			Location: quotationData.location,
			Margin: quotationData.margin,
			ModelNumber: quotationData.modelNumber,
			MotorSide: quotationData.motorSide,
			NagasProjectID: quotationData.NagasProjectID,
			NumberUnits: quotationData.numberUnits,
			PressureDrop_SA: quotationData.pressureDropSA,
			PressureDrop_RA: quotationData.pressureDropRA,
			Product: quotationData.product,
			Product_id: quotationData.product_id,
			ProductName: quotationData.productName,
			ProjectName: quotationData.projectName,
			ProjectNumber: quotationData.projectNumber,
			ProjectStatus: quotationData.projectStatus,
			Province:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.province
					: null,
			Quantity: quotationData.quantity,
			QuotationStatus: quotationData.quotationStatus,
			QuoteDate: formattedDate,
			QuoteType: quotationData.quotationType,
			Representative: quotationData.representative,
			ReturnAirESP: quotationData.returnAirESP,
			RoofCurb: 'Not Included',
			SelectionImportCode: quotationData.selectionImportCode,
			Shipping: quotationData.shipping,
			Specified: quotationData.specified,
			Stacked: quotationData.stacked,
			StartUp: quotationData.startUp,
			SubmittedBy: quotationData.submittedBy,
			SupplyAirESP: quotationData.supplyAirESP,
			Template_id: quotationData.template_id,
			UnitModel: quotationData.unitModel,
			UnitsTag: quotationData.unitsTag,
			UserId: quotationData.UserId,
			Voltage: quotationData.voltage,
			Weight: quotationData.weight,
			Width: quotationData.width
		};

		console.log("slice apiDataCommon: ", apiDataCommon)

		// Vérifier si on est en "création" ou en "révision"
		let response;
		if (quotationData.id) {

			//console.log("quotationData.id is defined: ", quotationData.id)

			const apiDataForUpdate = {
				SuperblockQuoteCode: quotationData.quote,
				...apiDataCommon,
			};
			response = await updateSuperblockQuotation(apiDataForUpdate);
		} else {

			response = await createSuperblockQuotation(apiDataCommon);
		}

		return response;
	}
);

const superblockQuotationSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.quotations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSuperblockQuotationAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSuperblockQuotationAsync.fulfilled, (state, action) => {
        state.quotations = action.payload;
      })
      .addCase(addSuperblockQuotationAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const superblockQuotationActions = {
  ...superblockQuotationSlice.actions,
  addSuperblockQuotationAsync,
};

export const superblockQuotationsReducer = superblockQuotationSlice.reducer;


